import React, {useState} from 'react'
import {
	Button,
	Container,
	Grid,
	useTheme
} from '@material-ui/core'
import {CamResponse} from '../../data-service'
import get from 'lodash/get'

interface AddProps {
    useThemeHook?: any;
    data: CamResponse;
}

export default function Add({useThemeHook = useTheme, data}: AddProps) {
	const theme = useThemeHook()
	const spacing: number = theme.spacing()
	const currentYear = new Date().getFullYear()

	const link = get(data, 'content.add[0].link', undefined)
	const img = get(data, 'content.add[0].img', undefined)
	const title = get(data, 'content.add[0].title', undefined)

	const [isAddVisible, setAddStatus] = useState(true)

	const btnStyle = {
		padding: '0',
		position: 'absolute',
		minWidth: '32px',
		backgroundColor: 'rgba(255,255,255, 0.7)',
		right: '8px',
		top: '8px'
	}

	return (
		<>{img && isAddVisible &&
        <div style={{position: 'fixed', bottom: `${2 * spacing}px`, width: '100%'}}>
        	<Container maxWidth="md" style={{position: 'relative'}}>
        		<Grid
        			className={'add-grid'}
        			container
        			spacing={2}
        			direction="row"
        			justifyContent="flex-start"
        			alignItems="flex-start"
        		>
        			<Button variant="outlined" style={{
        				padding: '0',
        				position: 'absolute',
        				minWidth: '32px',
        				backgroundColor: 'rgba(255,255,255, 0.7)',
        				right: '24px',
        				top: '8px'
        			}} onClick={() => setAddStatus(false)}>x</Button>
        			<a href={link} target={'_blank'} rel="noreferrer">
        				<img src={`http://tarnow.net.pl/uploads/advert/ORGINAL/${img}`} alt={title}
        					style={{width: '100%'}}/>
        			</a>
        		</Grid>
        	</Container>
        </div>}
		</>
	)
}